<template>
	<div class="right">
		<!--<button @click="back">back</button>-->
		<label for="select"></label>
		<select :title="!editing ? 'сохраните изменения...' : 'select'"
		        id="select"
		        :disabled="!editing"
		        @click="editPlaylistLeft2">
			<option :value="i"
			        v-for="(item, i) in getChannelList"
			        :key="i">
				{{item ? item.display_name : ""}} {{item.is_ottfree ? "OTT free" : ""}}
			</option>
		</select>
		<button id="newChannel"
		        :title="!editing ? 'сохраните изменения...' : 'new channel'"
		        @click="newChannel"
		        :disabled="!editing"
		        v-if="rules && (getReqUserRole === 'Power User' || getReqUserRole === 'Администратор уровня Бог')"
		>new channel
		</button>
		<button @click="deleteChannel"
		        v-if="rules && (getReqUserRole === 'Power User' || getReqUserRole === 'Администратор уровня Бог')"
		        v-show="getOtt"
		        class="delete"
		        :disabled="nonNative"
		>delete channel
		</button>
		<div class="wrap">
			<p>редактирование списка доступных каналов</p>
			<p>имя канала:
				<span class="bold">
					{{getChannelList[getCountChannel] ? getChannelList[getCountChannel].display_name : ""}}
				</span>
			</p>
		</div>
		<div class="container">
			<div class="wrap_options">
				<label for="disp_name">Отображаемое название</label>
				<input type="text"
				       id="disp_name"
				       :disabled="!rules || (!getOtt || !(getReqUserRole === 'Power User' || getReqUserRole ===
				        'Администратор уровня Бог')) || nonNative"
				       :value="getChannelList[getCountChannel] ? getChannelList[getCountChannel].display_name : ''"
				       @blur="edit"/>
			</div>
			<div class="wrap_options">
				<label for="name">Название канала на стримере</label>
				<input type="text"
				       id="name"
				       :disabled="!rules || (!getOtt || !(getReqUserRole === 'Power User' || getReqUserRole ===
				        'Администратор уровня Бог')) || nonNative"
				       :value="getChannelList[getCountChannel] ? getChannelList[getCountChannel].name : ''"
				       @blur="edit"
				       onkeyup="this.value = this.value.replace(/[^-0-9a-zA-Z]+$/, '')"/>
			</div>
			<div class="wrap_options">
				<label for="genre">
					<span>Жанр канала</span>
					<input type="button"
					       title="добавить еще жанр"
					       v-if="rules && (getReqUserRole === 'Power User' || getReqUserRole === 'Администратор уровня Бог')"
					       :class="{displayNone: !rules || !getOtt}"
					       v-show="!getChannelList[getCountChannel].is_ottfree || !nonNative"
					       @click="newGenre">
				</label>
				<div id="genre">
					<transition-group name="list-complete" tag="div">
						<div v-for="(group, i) in getChannelList[getCountChannel].genreList"
						     :key="i"
						     :value="group"
						     v-if="getChannelList[getCountChannel].is_ottfree && nonNative"
						     class="list-complete-item">
							<label class="label">
								<input type="text"
								       :disabled="nonNative"
								       :value="group.display_name">
							</label>
						</div>
						<div v-for="(group, i) in getChannelList[getCountChannel].genreList"
						     :key="i"
						     :value="group"
						     v-if="!getChannelList[getCountChannel].is_ottfree || !nonNative"
						     class="list-complete-item">
							<select title="genre"
							        name="display_name"
							        :disabled="!rules || (!getOtt || !(getReqUserRole === 'Power User' || getReqUserRole ===
				        'Администратор уровня Бог'))"
							        @blur="edit"
							        :id="i">
								<option :value="item.name"
								        v-for="(item, i) in genre"
								        :key="i">{{item ? item.display_name : ""}}
								</option>
							</select>
							<input type="button"
							       title="удалить жанр"
							       v-if="rules && (getReqUserRole === 'Power User' || getReqUserRole === 'Администратор уровня Бог')"
							       v-show="getOtt"
							       @click="deleteGenre">
						</div>
					</transition-group>
				</div>
			</div>
			<div class="wrap_options">
				<label for="censore">Возрастное ограничение</label>
				<select title="censore"
				        name="censore"
				        id="censore"
				        :disabled="!rules || (!getOtt || !(getReqUserRole === 'Power User' || getReqUserRole ===
				        'Администратор уровня Бог')) || nonNative"
				        @blur="edit">
					<option value="0">
						Без ограничений
					</option>
					<option value="1">
						Для взрослых
					</option>
				</select>
			</div>
			<div class="wrap_options">
				<label for="free">free</label>
				<select title="free"
				        name="free"
				        id="free"
				        :disabled="!rules || (!getOtt || !(getReqUserRole === 'Power User' || getReqUserRole ===
				        'Администратор уровня Бог')) || nonNative"
				        @blur="edit">
					<option value="0">
						Нет
					</option>
					<option value="1">
						Да
					</option>
				</select>
			</div>
			<div class="wrap_options"
			     v-show="getReqUserRole === 'Администратор уровня Бог'">
				<label for="ott_free">OTT free</label>
				<select title="ott_free"
				        name="ott_free"
				        id="ott_free"
				        :disabled="!rules || (!getOtt || !(getReqUserRole === 'Power User' || getReqUserRole ===
				        'Администратор уровня Бог')) || nonNative"
				        @blur="edit">
					<option value="0">
						Нет
					</option>
					<option value="1">
						Да
					</option>
				</select>
			</div>
			<div class="wrap_options">
				<label for="federal">Федеральный</label>
				<select title="federal"
				        name="federal"
				        id="federal"
				        :disabled="!rules || (!getOtt || !(getReqUserRole === 'Power User' || getReqUserRole ===
				        'Администратор уровня Бог')) || nonNative"
				        @blur="edit">
					<option value="0">
						Нет
					</option>
					<option value="1">
						Да
					</option>
				</select>
			</div>
			<div class="wrap_options">
				<label for="archive">Архив (часы)</label>
				<input type="text"
				       id="archive"
				       :disabled="!rules || (!getOtt || !(getReqUserRole === 'Power User' || getReqUserRole ===
				        'Администратор уровня Бог')) || nonNative"
				       :value="getChannelList[getCountChannel].archive_limit"
				       @blur="edit"
				       onkeyup="this.value = this.value.replace(/[^0-9]+$/, '')"/>
			</div>
			<div class="wrap_options">
				<label for="poster">Постер</label>
				<input type="text"
				       id="poster"
				       :disabled="!rules || (!getOtt || !(getReqUserRole === 'Power User' || getReqUserRole ===
				        'Администратор уровня Бог')) || nonNative"
				       :value="getChannelList[getCountChannel].poster_url"
				       @blur="edit"
				       onkeyup="this.value = this.value.replace(/[^-.:\/0-9_a-zA-Z]+$/, '')"/>
			</div>
			<div class="wrap_options">
				<label for="epg_api">Epg API</label>
				<input type="text"
				       id="epg_api"
				       :disabled="!rules || (!getOtt || !(getReqUserRole === 'Power User' || getReqUserRole ===
				        'Администратор уровня Бог')) || nonNative"
				       :value="getChannelList[getCountChannel].epg_api_id"
				       @blur="edit"
				       onkeyup="this.value = this.value.replace(/[^0-9]+$/, '')"/>
			</div>
			<div class="wrap_options">
				<label for="epg_jtv">Epg JTV</label>
				<input type="text"
				       id="epg_jtv"
				       :disabled="!rules || (!getOtt || !(getReqUserRole === 'Power User' || getReqUserRole ===
				        'Администратор уровня Бог')) || nonNative"
				       :value="getChannelList[getCountChannel].epg_jtv"
				       @blur="edit"
				       onkeyup="this.value = this.value.replace(/[^-\/0-9_a-zA-Z]+$/, '')"/>
			</div>
			<div class="wrap_options" v-if="getReqUserRole === 'Администратор уровня Бог'">
				<label for="operator">Оператор</label>
				<select name="operator"
				        id="operator"
				        disabled
				        @blur="edit"
				        v-model="getChannelList[getCountChannel].operator">
					<option :value="operator.name"
					        :key="operator.name"
					        v-for="operator in operatorList">{{operator.display_name}}
					</option>
				</select>
			</div>
		</div>
		<button @click="cancelChanges"
		        v-if="getUserRights"
		        v-show="getOtt"
		        :disabled="nonNative"
		>cancel changes
		</button>
		<button @click="save"
		        v-if="getUserRights"
		        v-show="getOtt"
		        :disabled="nonNative"
		>save
		</button>
		<transition name="error">
			<p id="error"
			   v-if="error">все поля должны быть заполнены!!!</p>
			<p id="no_correct"
			   v-if="no_correct">не корректно введены данные!!!</p>
		</transition>
	</div>
</template>
<script>
	import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
	import { performRequest }                                 from "../script/ws/wsclient";
	import { eventEmmiter }                                   from "../main";

	export default {
		name:     "PlaylistRight",
		data() {
			return {
				playlist:     [],
				genre:        "",
				error:        false,
				no_correct:   false,
				variable:     "",
				editing:      true,
				obj:          {},
				old_name:     "",
				operatorList: [],
				rules:        false,
				ott:          false,
				nonNative:    false
			};
		},
		beforeDestroy() {
			eventEmmiter.$off("errorSave");
		},
		created() {
			eventEmmiter.$on("errorSave", val => {
				if (val === "save") {
					this.save();
				} else if (val === "cancel") {
					this.cancelChanges();
				}
			});
		},
		beforeMount() {
			this.setCountChannel(0);
			this.getReqUserRole === "Администратор уровня Бог" ? this.setOtt(1) : this.setOtt(0);
			this.nonNative = this.getChannelList[this.getCountChannel].operator !== this.getViewUser;
			this.rules     = this.getReqUserRole === "Power User"
				|| this.getReqUserRole === "Администратор уровня Бог"
				|| this.getReqUserRole === "оператор";
			performRequest(
				{
					section: "tvcontent.channel",
					name:    "getChannelList"
				},
				{
					operator: this.getViewUser
				},
				a => {
					if (a.code === 200) {
						this.setChannelist(a.data);
						this.playlist = this.getChannelList;
						if (this.getChannelList[this.getCountChannel]) {
							this.setCh(this.getChannelList[this.getCountChannel].name);
						}
						Object.assign(this.thisChannel,
							this.getChannelList[this.getCountChannel]);
						delete this.thisChannel.genreList;
						if (this.getChannelList[this.getCountChannel]) {
							this.thisChannel.genreList =
								[].slice.call(this.getChannelList[this.getCountChannel].genreList);
						}

					} else {
						console.log("ошибка при получении доступных каналов");
					}
				}
			);
			performRequest(
				{
					section: "tvcontent.playlist",
					name:    "getPlaylistList"
				},
				{
					operator: this.getViewUser
				},
				a => {
					if (a.code === 200) {
						this.setPlaylists(a.data);
					} else {
						console.log("ошибка при получении плейлистов");
					}

				}
			);
			performRequest(
				{
					section: "tvcontent.genre",
					name:    "getGenreList"
				},
				{
					operator: this.getViewUser
				},
				a => {
					if (a.code === 200) {
						this.setGenre(a.data);
						this.genre = this.getGenre;
					} else {
						console.log("ошибка при получении жанров");
					}

				}
			);
			if (this.getReqUserRole === "Администратор уровня Бог") {
				performRequest(
					{
						section: "tvcontent.operator",
						name:    "getOperatorList"
					},
					{
						operator: this.getViewUser
					},
					a => {
						if (a.code === 200) {
							this.operatorList = a.data;
							console.log(a);
						} else {
							console.log("ошибка загрузки списка операторов");
						}
					});
			}

		},
		updated() {
			try {
				this.nonNative = this.getChannelList[this.getCountChannel].operator !== this.getViewUser;
			} catch (e) {
			}

			try {
				let options = Array.from(
					document.querySelectorAll("#genre div div select")
				);
				for (let item in options) {
					let optionItem = options[item].children;
					for (let elem in optionItem) {
						if (
							optionItem.hasOwnProperty(elem) &&
							this.getChannelList[document.querySelector("#cell.select")
								.getAttribute("value")].genreList[item] &&
							this.getChannelList[document.querySelector("#cell.select")
								.getAttribute("value")].genreList[item].name
							=== optionItem[elem].getAttribute("value")
						) {
							options[item].options.selectedIndex = elem;
						}
					}
				}
				document.querySelector("select#select").options.selectedIndex
					= this.getCountChannel;
				
				document.querySelector("select#censore").selectedIndex
					= this.getChannelList[document.querySelector("#cell.select")
					.getAttribute("value")].is_censored;
				
				document.querySelector("select#federal").selectedIndex
					= this.getChannelList[document.querySelector("#cell.select")
					.getAttribute("value")].is_federal;
				
				document.querySelector("select#ott_free").selectedIndex
					= this.getChannelList[document.querySelector("#cell.select")
					.getAttribute("value")].is_ottfree;
				
				document.querySelector("select#free").selectedIndex
					= this.getChannelList[document.querySelector("#cell.select")
					.getAttribute("value")].is_free;
				
			} catch (e) {
			}
		},
		computed: {
			...mapState(["thisChannel", "channelList"]),
			...mapGetters([
				"getCountPlaylists",
				"getCountChannel",
				"getChannelList",
				"getGenre",
				"getUserRights",
				"getCh",
				"getThisChannel",
				"getCountChannel",
				"getReqUserRole",
				"getCurrentOperator",
				"getOtt",
				"getViewUser",
			])
		},
		methods:  {
			...mapMutations([
				"setCountChannel",
				"setThisChannel",
				"setCh",
				"setGenre",
				"setEditingChannelList",
				"setOtt"
			]),
			...mapActions([
				"setChannelist",
				"setPlaylists"
			]),
			save() {
				if (
					document.querySelector("#archive").value.trim() !== "" &&
					document.querySelector("#disp_name").value.trim() !== "" &&
					document.querySelector("#name").value.trim() !== "" &&
					document.querySelector("#poster").value.trim() !== "" &&
					document.querySelector("#epg_api").value.trim() !== "" &&
					document.querySelector("#epg_jtv").value.trim() !== ""
				) {
					let playlist      = this.getChannelList[this.getCountChannel];
					playlist.old_name = this.getCh;

					if (this.getReqUserRole === "Администратор уровня Бог") {
						playlist.operator = this.getViewUser;
					} else {
						playlist.operator = this.getChannelList[this.getCountChannel].operator;
					}

					if (!this.getChannelList[this.getCountChannel].is_ottfree) {
						for (let elem in playlist.genreList) {
							if (playlist.genreList.hasOwnProperty(elem)) {
								let value = playlist.genreList[elem].name;
								for (let elem2 in playlist.genreList) {
									if (playlist.genreList.hasOwnProperty(elem2)) {
										if (playlist.genreList[elem] !== playlist.genreList[elem2]) {
											if (value === playlist.genreList[elem2].name) {
												playlist.genreList.splice(elem2, 1);
											}
										}
									}
								}
							}
						}
						
						this.getChannelList[this.getCountChannel]
							.genreList
							.splice(0, this.getChannelList[this.getCountChannel].genreList.length);
						let genre = Array.from(document.querySelectorAll("#genre div div select"));
						for (let i in genre) {
							let obj = {
								name:         genre[i].children[genre[i].selectedIndex].value,
								display_name: genre[i].children[
									              genre[i].selectedIndex
									              ].innerText
									              .replace(/\r|\n/g, "")
									              .trim()
							};
							this.getChannelList[this.getCountChannel].genreList.push(obj);
						}
					}
					performRequest(
						{
							section: "tvcontent.channel",
							name:    "updateChannel"
						},
						playlist,
						a => {
							if (a.code === 200) {
								performRequest(
									{
										section: "tvcontent.channel",
										name:    "getChannelList"
									},
									{
										operator: this.getViewUser
									},
									b => {
										if (b.code === 200) {
											this.setChannelist(b.data);
											
											this.editing = true;
											
											this.setEditingChannelList(this.editing);
											
											Object.assign(this.thisChannel,
												this.getChannelList[this.getCountChannel]);
											
											delete this.thisChannel.genreList;
											
											this.thisChannel.genreList =
												[].slice.call(this.getChannelList[this.getCountChannel].genreList);
											
											this.setCh(this.getChannelList[this.getCountChannel].name);
											
											this.error = false;
											
											eventEmmiter.$emit("hiddenPopupCh", true);
										} else {
											console.log("ошибка при получении");
										}
									}
								);
							} else if (a.code === 500) {
								this.no_correct = true;
							} else {
								console.log("ошибка при отправке");
							}
						}
					);
				} else {
					this.error = true;
				}
			},
			newGenre() {
				this.getChannelList[
					document.querySelector("#cell.select").getAttribute("value")
					].genreList.push({
					name:         this.genre[0].name,
					display_name: this.genre[0].display_name
				});
				this.editingChange();
			},
			editingChange() {
				this.editing = ( _.isEqual(this.thisChannel,
					this.getChannelList[this.getCountChannel]) &&
					_.isEqual(this.thisChannel.genreList,
						this.getChannelList[this.getCountChannel].genreList) );
				this.setEditingChannelList(this.editing);
			},
			deleteGenre(e) {
				this.getChannelList[
					document.querySelector("#cell.select").getAttribute("value")
					].genreList.splice(e.target.previousElementSibling.id, 1);
				this.editingChange();
			},
			deleteChannel() {

				performRequest(
					{
						section: "tvcontent.channel",
						name:    "deleteChannel"
					},
					{
						name:     this.getCh,
						operator: this.getViewUser
					},
					a => {

						if (a.code === 200) {
							if (this.getCountChannel === this.getChannelList.length - 1) {
								this.setCountChannel(0);
							}

							performRequest(
								{
									section: "tvcontent.channel",
									name:    "getChannelList"
								},
								{
									operator: this.getViewUser
								},
								b => {
									if (b.code === 200) {
										this.setChannelist(b.data);
										
										this.setCh(this.getChannelList[this.getCountChannel].name);
										
										this.editing = true;
										
										this.setEditingChannelList(this.editing);
										
										this.setOtt(this.getChannelList[this.getCountChannel].is_ottfree);
									} else {
										console.log("ошибка при получении");
									}
								}
							);
						} else {
							console.log("ошибка при отправке");
						}
					}
				);
			},
			edit() {
				this.getChannelList[this.getCountChannel].genreList
					.splice(0, this.getChannelList[this.getCountChannel].genreList.length);
				
				let genre = Array.from(document.querySelectorAll("#genre div div select"));
				
				for (let i in genre) {
					let obj = {
						name:         genre[i].children[
							              genre[i].selectedIndex
							              ].value,
						display_name: genre[i].children[
							              genre[i].selectedIndex
							              ].innerText
							              .replace(/\r|\n/g, "")
							              .trim()
					};
					this.getChannelList[this.getCountChannel].genreList.push(obj);
				}

				this.getChannelList[this.getCountChannel]
					.archive_limit = +document.querySelector("#archive").value.trim();
				
				this.getChannelList[this.getCountChannel]
					.display_name  = document.querySelector("#disp_name").value.trim();
				
				this.getChannelList[this.getCountChannel]
					.name          = document.querySelector("#name").value.trim();
				
				this.getChannelList[this.getCountChannel]
					.poster_url    = document.querySelector("#poster").value.trim();
				
				this.getChannelList[this.getCountChannel]
					.is_censored   = document.querySelector("#censore").selectedIndex;
				
				this.getChannelList[this.getCountChannel]
					.is_federal    = document.querySelector("#federal").selectedIndex;
				
				this.getChannelList[this.getCountChannel]
					.is_ottfree    = document.querySelector("#ott_free").selectedIndex;
				
				this.getChannelList[this.getCountChannel]
					.is_free       = document.querySelector("#free").selectedIndex;
				
				this.getChannelList[this.getCountChannel]
					.epg_api_id    = +document.querySelector("#epg_api").value.trim();
				
				this.getChannelList[this.getCountChannel]
					.epg_jtv       = document.querySelector("#epg_jtv").value.trim();

				this.editingChange();

			},
			editSelector() {
				document.documentElement.scrollTop = 0;
				let row                            = Array.from(document.querySelectorAll(".left2 #cell"));
				for (let i in row) {
					if (row.hasOwnProperty(i)) {
						row[i].classList.remove("select");
						
						row[this.getCountChannel].classList.add("select");
					}
				}
			},
			editPlaylistLeft2(e) {
				this.setCountChannel(e.currentTarget.options.selectedIndex);
				
				this.setCh(this.getChannelList[this.getCountChannel].name);
				
				this.editSelector();
				
				this.setOtt(this.getChannelList[this.getCountChannel].is_ottfree);
				
				Object.assign(this.thisChannel,
					this.getChannelList[this.getCountChannel]);
				
				delete this.thisChannel.genreList;

				this.thisChannel.genreList =
					[].slice.call(this.getChannelList[this.getCountChannel].genreList);
			},
			newChannel() {
				this.$router.push("/new_channel");
			},
			cancelChanges() {

				performRequest(
					{
						section: "tvcontent.channel",
						name:    "getChannelList"
					},
					{
						operator: this.getViewUser
					},
					b => {
						if (b.code === 200) {
							this.setChannelist(b.data);
							
							this.setCh(this.getChannelList[this.getCountChannel].name);
							
							this.editing = true;
							
							this.setEditingChannelList(this.editing);
							
							eventEmmiter.$emit("hiddenPopupCh", true);
						} else {
							console.log("ошибка при получении");
						}
					}
				);
				this.editingChange();
			}
		},
	};
</script>
<style scoped lang="scss">
	.right {
		background-color: rgba(238, 238, 200, 0.8);
		box-shadow: inset 0 0 5px rgba(#333, 0.4), 1px 1px 5px #333;
		padding: 0.5rem 0.5rem 1rem 0.5rem;
		height: calc(100vh - 5rem);
		overflow: auto;
		min-width: 450px;
		width: 100%;
		z-index: 1000;
		select#select, button {
			background: #bbf291;
			border-radius: 0.2rem;
			line-height: 1.8rem;
			border: none;
			outline: none;
			height: 2.5rem;
			padding: 0.2rem 1rem;
			transition: all 0.2s;
			cursor: pointer;
			margin: 0.5rem;
			
			&:disabled {
				background-color: rgba(157, 174, 146, 0.54);
				&:hover {
					background-color: rgba(157, 174, 146, 0.54);
					cursor: default;
					&:active {
						box-shadow: 0 0 1rem #967068;
					}
				}
			}
			&:hover {
				background: #78956b;
				color: white;
				
				&:active {
					box-shadow: 0 0 1rem #967068;
				}
			}
		}
		.delete {
			margin-left: 30px;
			background-color: #ffbeba;
		}
		button[title='newChannel'], select#select {
			display: inline-block;
			
			option {
				background-color: #fff;
				color: #000;
			}
		}
		button[title='newChannel'] {
			display: inline-block
		}
		select#select {
			display: none;
		}
		
		.container {
			clear: both;
			margin: 0.5rem 0.5rem 0.5rem 50%;
			width: 90%;
			transform: translateX(-50%);
			.wrap_options {
				width: 100%;
				display: flex;
				justify-content: space-between;
				flex-wrap: wrap;
				margin: 0.5rem;
				.displayNone {
					display: none;
				}
				input[type="button"] {
					outline: none;
					border: none;
					background: url("../../static/plus.png") no-repeat center;
					background-size: 75%;
					width: 2rem;
					height: 2rem;
					position: absolute;
					top: -3px;
					left: 6.5rem;
					cursor: pointer;
				}
				input[type='text'], select#censore, select#federal, select#ott_free, select#operator, select#free {
					min-width: 27rem;
					max-width: 50rem;
					border-radius: 3px;
					outline: none;
					border: 1px solid #c9c9c9;
					padding-left: 5px;
					flex-grow: 1;
					margin-bottom: 5px;
					height: 1.7rem;
					&:focus {
						box-shadow: 0 0 5px #69bf8f;
					}
				}
				#genre {
					min-width: 27rem;
					max-width: 50rem;
					flex-grow: 1;
					div {
						div {
							display: flex;
							flex-direction: row;
							justify-content: space-between;
							flex-grow: 1;
							label {
								width: 100%;
								margin: 0;
								padding: 0;
								input {
									width: 100%;
									padding: 6px;
								}
							}
							select {
								flex-grow: 1;
								border-radius: 3px;
								outline: none;
								border: 1px solid #c9c9c9;
								padding-left: 2px;
								margin-bottom: 5px;
								height: 1.7rem;
								&:focus {
									box-shadow: 0 0 5px #69bf8f;
								}
							}
							input[type="button"] {
								outline: none;
								border: none;
								background: url("../../static/minus.png") no-repeat center;
								background-size: 75%;
								width: 2rem;
								height: 2rem;
								top: -3px;
								left: 6.5rem;
								cursor: pointer;
								position: static;
								margin-top: -3px;
							}
						}
					}
				}
				select#censore, select#federal, select#ott_free, select#operator, select#free {
					padding-left: 2px;
				}
				
				label {
					width: 18rem;
					position: relative;
				}
			}
		}
		p#error, p#no_correct {
			display: inline-block;
			font-size: 1.1rem;
			color: red;
		}
		.wrap {
			margin: 0.1rem 0.5rem;
			float: right;
			
			p {
				margin: 0;
			}
			
			.bold {
				font-weight: bold;
			}
		}
	}
	@media (max-width: 750px) {
		.right {
			height: calc(100vh - 5rem);
			width: 100%;
			overflow: auto;
			
			button[title='newChannel'], select#select {
				display: inline-block;
			}
		}
	}
	@media (max-width: 620px) {
		.right {
			height: calc(100vh - 9rem);
			margin-top: 4rem;
		}
	}
	.list-complete-item {
		transition: all .5s;
	}
	.list-complete-enter {
		opacity: 0;
		transform: translateX(30px);
	}
	.list-complete-leave-to {
		opacity: 0;
		transform: translateX(-30px);
	}
	.error-enter-active {
		transition: all 0.5s ease;
	}
	.error-leave-active {
		transition: all 0.5s ease;
	}
	.error-enter, .error-leave-to {
		opacity: 0;
	}
</style>



// WEBPACK FOOTER //
// src/components/PlaylistRight.vue